interface UsersEmptyIconProps {
  className?: string;
}

function UsersEmptyIcon({ className }: UsersEmptyIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.667 56V50.667C42.667 47.838 41.543 45.125 39.543 43.124C37.543 41.124 34.829 40 32 40H13.333C10.504 40 7.791 41.124 5.791 43.124C3.79 45.125 2.667 47.838 2.667 50.667V56M58.667 56V50.667C58.665 48.302 57.879 46.007 56.43 44.139C54.982 42.272 52.952 40.938 50.667 40.347M40 8.347C42.29 8.935 44.325 10.268 45.777 12.138C47.228 14.008 48.015 16.307 48.015 18.677C48.015 21.046 47.228 23.345 45.777 25.215C44.325 27.085 42.29 28.418 40 29.007M34.667 18.667C34.667 24.558 29.891 29.333 24 29.333C18.109 29.333 13.333 24.558 13.333 18.667C13.333 12.776 18.109 8 24 8C29.891 8 34.667 12.776 34.667 18.667Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UsersEmptyIcon;
